// Pet sprite emoji fallbacks, keyed to the pet_catalog slugs seeded in
// migration 0181. Used when the real SVG sprite asset isn't bundled
// yet (M1 ships before art). Each slot is a fallback emoji + an
// `accent` color hint the pet card can pull from for backgrounds.
//
// EMOJI-IN-UI EXCEPTION: this file lives under src/experiments/kids-mode
// which is the explicit opt-in to emojis per the plan. The no-emoji
// rule still applies everywhere else in the app.
//
// When a real SVG sprite lands at /pet-sprites/<slug>.svg, the client
// prefers the SVG (loaded via pet.image_url from pet_catalog) and
// only falls back to this map when the asset 404s.

export const PET_FALLBACK = {
  booda: { emoji: "🦊", accent: "#F5B25E" },
  pip:   { emoji: "🦔", accent: "#B58463" },
  momo:  { emoji: "🐼", accent: "#2C2C2C" },
  nori:  { emoji: "🦦", accent: "#7A4E2D" },
  // Phase 1 roster expansion (migration 0222). Real art bundles land
  // later; emoji + accent here cover the gap so the picker grid + Pet
  // sprite render until the per-pet PNG bundles are authored.
  alien:    { emoji: "👽", accent: "#7EFF8C" },
  bob:      { emoji: "👽", accent: "#7EFF8C" },
  evans:    { emoji: "👽", accent: "#A0E0FF" },
  steve:    { emoji: "👽", accent: "#FFC8E0" },
  princess: { emoji: "🐱", accent: "#F8C8DC" },
  peach:    { emoji: "🐱", accent: "#F5B284" },
  lavender: { emoji: "🐱", accent: "#C8B5E0" },
};

export const MOOD_FACE = {
  happy:   "😊",
  content: "🙂",
  calm:    "😌",
  sleepy:  "😴",
};

export function petFallbackFor(slug) {
  return PET_FALLBACK[slug] || PET_FALLBACK.booda;
}
